module.exports = __webpack_public_path__ + "static/media/profile_icon.227c4780.png";